<template>
    <div>
        <div style="color: #00ff96;font-size: 1rem">转移申请</div>
        <form :form="form">
            <div style="display: flex;justify-content: space-between;">
                <SelectField labelWidth="40%" label="申请人" style="margin: 0.5rem 0.2rem;width:45%" id="applicantId"
                             :modelValue="detail.applicantId" :options="userList" required
                             @update:modelValue="(value) => handleModelValueUpdate('applicantId', value)"
                />
                <DatePickerField labelWidth="40%" label="申请时间" required style="margin: 0.1rem 0.1rem 0.1rem 0;width:45%"
                                 id="transferTime"
                                 name="transferTime" placeholder="请选择日期"
                                 :rules="[{ required: true, message: '请选择日期' }]"
                                 :modelValue="detail.transferTime"
                                 @update:modelValue="(value) => handleModelValueUpdate('transferTime', value)"
                />
            </div>
            <div>
                <TextareaField :modelValue="detail.reason" id="reason" required labelWidth="14%" style="margin: 0.5rem 0.2rem" label="转移原因"
                               @update:modelValue="(value) => handleModelValueUpdate('reason', value)"
                />
                <TextareaField :modelValue="detail.remark" labelWidth="14%" style="margin: 0.5rem 0.2rem" label="备注"
                               id="remark"  @update:modelValue="(value) => handleModelValueUpdate('remark', value)"
                />
            </div>
            <div class="formDiv">
                <div style="display: flex;justify-content: start">
                    <div style="width:10%;margin:1rem 0 1rem 1rem;color:#8290a7;">附件</div>
                    <Upload :list="fileList" @change="(list) => (fileList = list)" />
                </div>
            </div>
            <div class="formDiv">
                <Goods :selected="selected" @close-add-modal="handleCloseAddModal"/>
            </div>
            <div class="formButton">
                <a-space>
                    <ButtonField text="关闭" @click="cancel" secondary />
                    <ButtonField text="保存" primary @click="handleSubmit"/>
                </a-space>
            </div>
        </form>
    </div>
</template>

<script>
import { edit, fetchDetail } from "../api/transfer";
import Goods from "./components/goods.vue";
import moment from "moment";
import { mapState } from "vuex";
export default {
  components: {
    Goods,
  },

  computed: {
    ...mapState("userSelector", ["userList"]),
  },
  props:{
      id:{
          type:String,
          required:true
      }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      detail: {},
      selected: [],
      fileList: [],

      loading: false,
    };
  },

  mounted() {
    fetchDetail({
      id:this.id,
    }).then((res) => {
      if (res) {
        this.detail = res;
        this.selected = Array.isArray(this.detail.materialList)
          ? this.detail.materialList
          : [];
        this.fileList = res.attachmentList ? res.attachmentList : [];
      }
    });
  },
  methods: {
    handleCloseAddModal() {
        this.visible = false;
    },
    moment,
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;
          console.log(values);
          edit({
            // id: this.detail.id,
            // consumerId: this.detail.consumerId,
            ...this.detail,
            ...values,
            applicant: this.userList.find(
              (item) => item.id === values.applicantId
            ).name,
            transferTime: values.transferTime.format("YYYY-MM-DD"),
            materialList: this.selected.map((item) => {
              return {
                mid: item.mid ? item.mid : item.id,
                code: item.code,
                name: item.name,
                brand: item.brand,
                specification: item.specification,
                unit: item.unit,
                price: item.price,

                chargerOldId: item.chargerOldId
                  ? item.chargerOldId
                  : item.chargerId,
                chargerOld: item.chargerOld ? item.chargerOld : item.charger,

                chargerNewId: item.chargerNewId,
                chargerNew: this.userList.find(
                  (element) => element.id === item.chargerNewId
                )?.name,
              };
            }),
            attachments: this.fileList.map((item) => item.id).join(","),
            status: "REVIEWING",
          })
            .then(() => {
              this.cancel();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },

    cancel() {
        this.$emit('show-transfer-index');
    },
  },
};
</script>
<style scoped>
.formButton{
    width: 100%;
    text-align: center;
    margin-top:1.5rem;
}
</style>
